<template>
    <div class="Transporteurs">
        <p class="SubTitle">{{ langPage['compte-menu']['TXT_mestransporteurs'] }}</p>
        <addCarte
                @submit="submit"
                :msg="msg"
                :carteTitle="carteTitle"
                :width="!$store.state.isMobile?4.16:80"
                buttonVal="Utiliser un nouveau transporteur"
                :is-show-country="false"
        ></addCarte>
    </div>
</template>
<script>
    import {mapState, mapMutations} from "vuex";
    import addCarte from "../../components/addCarte";

    export default {
        name: "Transporteurs",
        components: {
            addCarte
        },


        data() {
            return {
                submitState: true,
                carteTitle: [
                    //{"libelle":"test",
                    //  "id_client_transporteur":"123",
                    //  "id_acheteur":"73711",
                    //  "email":"",
                    //  "telephone":"",
                    //  "fax":"",
                    //  "commentaires":"",
                    //  "site_web":""
                    // }
                    {
                        title: "Nom du Transporteur",
                        key: "libelle"
                    },
                    {
                        title: "Votre identifiant",
                        key: "id_client_transporteur"
                    },
                    {
                        title: "Adresse email",
                        key: "email"
                    },
                    {
                        title: "Téléphone",
                        key: "telephone"
                    },
                    {
                        title: "Site internet",
                        key: "site_web"
                    },
                    {
                        title: "Commenaire",
                        key: "commentaires",
                        type: "textarea"
                    },
                    {
                        title: "fax",
                        key: "fax"
                    },
                    {
                        title: "",
                        key: "id_acheteur"
                    },
                    {
                        title: "",
                        key: "id_livraison"
                    },
                ],
                msg: [
                    // {
                    //  "libelle":"test",
                    //   "id_client_transporteur":"123",
                    //   "id_acheteur":"73711",
                    //   "email":"152@qq.com",
                    //   "telephone":"13152653262",
                    //   "fax":"46515@fax",
                    //   "commentaires":"ddddd",
                    //   "site_web":"qwww.baidu",
                    //   "transporteur":"cc"
                    // },

                ]
            };
        },
        computed: {
            ...mapState({
                acheteurId: state => state.acheteurId
            }),

        langPage() {
          return this.$store.state['langPage']
        }
      },
        created() {
            this.init()
        },
        methods: {
            init() {
                let acheteurId = this.acheteurId || localStorage.getItem('id_acheteur')
                this.$api.info.getDelivary({id: acheteurId}).then(res => {
                    this.msg = res;
                }).finally(() => {
                    this.submitState = true
                })
            },
            deleteDelivary(obj) {
                this.$api.info.deleteDelivary(obj).then(res => {
                    this.addDelivary(obj)
                })
            },
            addDelivary(data) {
                let obj = {
                    libelle: "",
                    id_client_transporteur: "",
                    id_acheteur: "",
                    email: "",
                    telephone: "",
                    fax: "",
                    commentaires: "",
                    site_web: ""
                }
                for (var key in data) {
                    for (var key1 in obj) {
                        if (key1 == key) {
                            obj[key1] = data[key]
                        }
                    }
                }
                obj.id_acheteur = this.acheteurId || localStorage.getItem('id_acheteur')
                this.$api.info.addDelivary(obj).then(res => {
                    this.init()
                    this.$router.go(0)
                })
            },
            submit(data, num) {
                if (!this.submitState) return
                this.submitState = false
                if (num == 0) {  //编辑
                    this.deleteDelivary(data)
                } else {   //添加
                    this.addDelivary(data)
                }
            }
        }
    };
</script>
<style lang="less" scoped src="@/assets/viewCss/views/Moncompte/Transporteurs.less">
</style>
